import React, { useState, useEffect, useRef } from 'react'

import DownloadIcon from 'Assets/Images/icons/download'
import LoadingIndicator from '../../../../LoadingIndicator/LoadingIndicator'
import { CONVERSION_REPORT_TYPE } from '../../../../../shared/constants'

import {
  StyledWrapper,
  StyledLoadingWrapper,
  StyledButton,
  StyledDownloadLink,
} from './styles'

import moment from 'moment'

const AsyncCSV = ({
  isUSFormat,
  conversionLogId,
  reportType,
  getConversionsData,
}) => {
  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const linkRef = useRef(null)

  useEffect(() => {
    if (data.length && linkRef.current) {
      linkRef.current.link.click()
    }
  }, [data])

  const downloadReport = async () => {
    setIsLoading(true)
    const data = await getConversionsData({ conversionLogId, reportType })
    if (reportType === CONVERSION_REPORT_TYPE.WITH_TIMESTAMP) {
      data.forEach((row, index) => {
        if (index) {
          row[2] = isUSFormat
            ? moment
                .unix(row[2])
                .utc()
                .format('MM/DD/YYYY HH:mm:ss')
            : moment
                .unix(row[2])
                .utc()
                .format('DD/MM/YYYY HH:mm:ss')
        }
      })
    }
    setIsLoading(false)
    setData(data)
  }

  return (
    <StyledWrapper>
      {!isLoading ? (
        <StyledButton onClick={downloadReport}>
          <DownloadIcon />
        </StyledButton>
      ) : (
        <StyledLoadingWrapper>
          <LoadingIndicator label="" size={20} />
        </StyledLoadingWrapper>
      )}
      <StyledDownloadLink ref={linkRef} data={data} filename="report.csv" />
    </StyledWrapper>
  )
}

export default AsyncCSV
